import axios from 'axios'
import { host } from '../configuraciones'
import { v4 as uuidv4 } from 'uuid';

//constantes
const dataInicial = {
    data: {
        fc_01_solicitudderegistro: [],
        fc_05_solicitudusomarcaeimagen: [],
        fc_06_registrodemaguey: [],
        fc_08_solicitudrenvacioncertificados: [],
        fc_09_solicitudemicioncertificadonomexportacionyentregahologram: [],
        fc_30_notificaciontrasladodeproducto: [],
        fc_31_solicitudseguimiento: [],
        fc_33_solicitudenvasadonacional: [],
        fc_34_notificacionsuspencionyreactivacion: [],
        fc_35_notificaciondeserviciosvarios: [],
        fc_36_solicituddeactualizacion: [],
        fc_40_solicituddeadquisiciondehologramas: [],
        fc_41_solicitudparabebidasconmezcal: []
    },
    status: 0,
    detalle: {},
    certificados: {},
    revision: false,
    formato : {},
    modoAtencionACliente: false,
}

//types
const OBTENER_TODAS_LAS_SOLICITUDES_ERROR = 'OBTENER_TODAS_LAS_SOLICITUDES_ERROR'
const OBTENER_TODAS_LAS_SOLICITUDES_STATUS_EXITO = 'OBTENER_TODAS_LAS_SOLICITUDES_STATUS_EXITO'
const ACTUALIZAR_FORMATOS_EXITO = 'ACTUALIZAR_FORMATOS_EXITO'
const OBTENER_TODAS_LOS_CERTIFICADOS_STATUS_EXITO = 'OBTENER_TODAS_LOS_CERTIFICADOS_STATUS_EXITO'
const OBTENER_UNA_SOLICITUID_DETALLE_EXITO = 'OBTENER_UNA_SOLICITUID_DETALLE_EXITO'
const OBTENER_SOLICITUDES_ERROR = 'OBTENER_SOLICITUDES_ERROR'
const OBTENER_SOLICITUID_DETALLE_EXITO = 'OBTENER_SOLICITUID_DETALLE_EXITO'
const AGREGAR_OBSERVACIONES_EXITO = 'AGREGAR_OBSERVACIONES_EXITO'
//redcuer
export default function AtencionClientesReducer(state = dataInicial, action) {
    switch (action.type) {
        case OBTENER_TODAS_LAS_SOLICITUDES_STATUS_EXITO:

            return { ...state, data: action.payload.data, status: action.payload.status, revision: false }
        case OBTENER_TODAS_LAS_SOLICITUDES_ERROR:
            return { ...state }
        case ACTUALIZAR_FORMATOS_EXITO:
            return { ...state, detalle: action.payload, revision: action.payload.revision }
        case OBTENER_TODAS_LOS_CERTIFICADOS_STATUS_EXITO:
            return { ...state, certificados: action.payload }
        case OBTENER_UNA_SOLICITUID_DETALLE_EXITO:
            return { ...state, detalle: action.payload.detalle }
            case OBTENER_SOLICITUID_DETALLE_EXITO:
            return { ...state, formato: action.payload.detalle, modoAtencionACliente : true }
        case OBTENER_SOLICITUDES_ERROR:
            return { ...state }
            case AGREGAR_OBSERVACIONES_EXITO:
            return { ...state }
        default:
            return state
    }
}

//acciones
export const obtenerTodasLasSolicitudesWithStatusEnviado = (params) => async (dispatch) => {
    try {
        const fullUrl = host + `Estatus/obtenerTodasLasSolicitudesConEstatus/estatus=${params.status}`
        const res = await axios.get(fullUrl)
        dispatch({
            type: OBTENER_TODAS_LAS_SOLICITUDES_STATUS_EXITO,
            payload: { data: res.data.data, status: params.status }

        })
        return res
    } catch (error) {
        console.log(error)
        dispatch({
            type: OBTENER_TODAS_LAS_SOLICITUDES_ERROR
        })
    }

}
//actualizar los formatos para en proceso
export const AcualizarFormatoAccion = (data) => async (dispatch) => {
    try {
        const fullUrl = host + `Estatus/actualizarEstatusRevisar`
        const res = await axios.post(fullUrl, { data })
        const dato = await dispatch({
            type: ACTUALIZAR_FORMATOS_EXITO,
            payload: { detalle: { data }, revision: data.revision }
        })
        return true
    } catch (error) {
        console.log(error)
    }
}
export const obtenertodosLosCertificadosPorId = (id) => async (dispatch) => {
    try {
        const fullUrl = host + `InformacionValida/obtenerCertificado/=${id}`
        const res = await axios.get(fullUrl)
        dispatch({
            type: OBTENER_TODAS_LOS_CERTIFICADOS_STATUS_EXITO,
            payload: { certificados: res.data.data }
        })
        return res
    } catch (error) {
        console.log(error)
        dispatch({
            type: OBTENER_TODAS_LAS_SOLICITUDES_ERROR
        })
    }

}
export const obetenerSolicitudDetalle = (data) => async (dispatch) => {
    try {
        const fullUrl = host + data.row.uri + data.row.Folio
        const res = await axios.get(fullUrl)
        dispatch({
            type: OBTENER_UNA_SOLICITUID_DETALLE_EXITO,
            payload: { detalle: res.data.data }
        })
    } catch (error) {
        console.log(error)
        dispatch({
            type: OBTENER_SOLICITUDES_ERROR
        })

    }
}
export const obetenerFormatoDetalle = (uri,idSolicitud) => async (dispatch) => {
    try {
        const fullUrl = host + uri + idSolicitud
        const res = await axios.get(fullUrl)

        for(let i in res.data.data.fc_01_anexounidaddealmacen) {         
            res.data.data.fc_01_anexounidaddealmacen[i]['id'] = uuidv4()
        }

        for(let i in res.data.data.fc_01_anexounidaddeenvasado) {
            res.data.data.fc_01_anexounidaddeenvasado[i]['id'] = uuidv4()
        }

        for(let i in res.data.data.fc_01_anexounidaddeproduccion) {
            res.data.data.fc_01_anexounidaddeproduccion[i]['id'] = uuidv4()
        }

        for(let i in res.data.data.fc_01_anexopersonaautorizadatramites) {
            res.data.data.fc_01_anexopersonaautorizadatramites[i]['id'] = uuidv4()  
        }

        for(let i in res.data.data.fc_01_anexomarcas) {
            res.data.data.fc_01_anexomarcas[i]['id'] = uuidv4()  
        }

        dispatch({
            type: OBTENER_SOLICITUID_DETALLE_EXITO,
            payload: { detalle: res.data.data, modoAtencionACliente:true }
        })
        return res
    } catch (error) {
        console.log(error)
        dispatch({
            type: OBTENER_SOLICITUDES_ERROR
        })

    }
}
export const agregarObservacionAccion = (data) => async (dispatch) => {
    try {
        const fullUrl = host + `AtencionAClientes/agregarNuevaObservacion`
        const res = await axios.post(fullUrl, { data })
        dispatch({
            type: AGREGAR_OBSERVACIONES_EXITO,
            payload: res.data.data
        })
        return res
    } catch (error) {
        console.log(error)
    }
}